import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useMemo } from "react";
import { mapPayoutStatus } from "../mappers/payouts.mapper";
import type { AllPayoutsFiltersType } from "../types/payouts.type";
import { useQuery } from "@tanstack/react-query";

export function useFetchAllPayouts(
  filters: AllPayoutsFiltersType = {},
  cursor?: string
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const queryInput = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      cursor,
      batchId:
        filters.batchId && filters.batchId.trim() !== ""
          ? filters.batchId.trim()
          : undefined,
      customerDocumentNumber:
        filters.customerDocumentNumber &&
        filters.customerDocumentNumber.trim() !== ""
          ? filters.customerDocumentNumber.trim()
          : undefined,
      createdAtRange: filters.dateRange
        ? ([
            `${filters.dateRange[0]}T00:00:00.000`,
            `${filters.dateRange[1]}T23:59:59.999`,
          ] as [string, string])
        : undefined,
      statuses:
        filters.status &&
        mapPayoutStatus[filters.status as keyof typeof mapPayoutStatus]
          ? [mapPayoutStatus[filters.status as keyof typeof mapPayoutStatus]]
          : undefined,
    }),
    [merchant?.id, cursor, filters]
  );

  const { data, isLoading, refetch } = useQuery(
    trpc.payouts.list.queryOptions(queryInput, {
      enabled: !!merchant?.id,
    })
  );

  const payouts = data?.data || [];
  const nextCursor = data?.cursor || undefined;

  return { payouts, nextCursor, isLoading, refetch };
}
